import { COLORS } from '@btime/constants'
import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useFilterState } from '@btime/react-contexts'
import React from 'react'

import { Text } from '../../../components/presentation/Text'
import { serviceOrdersClient } from '../../../utils/apollo/api'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import { convertFilterToRelativeDates } from '../../../utils/helpers/date'

const QUERY = gql`
  query ServiceOrdersCount($search: String, $searchType: ServiceOrderSearchType, $filter: ServiceOrderFilter) {
    serviceOrdersCount(search: $search, searchType: $searchType, filter: $filter)
  }
`

const ListCounter = ({ client, filters, flexiblePollInterval }) => {
  const { search, searchType } = useFilterState()
  let filter = { ...useCleanFilterForRequest(), ...filters }
  filter = convertFilterToRelativeDates(filter)

  const { data, loading } = useQuery(QUERY, {
    variables: {
      search,
      searchType: !!searchType && !!search ? searchType : undefined,
      filter
    },
    client: serviceOrdersClient,
    flexiblePollInterval: flexiblePollInterval || 120000
  })

  if (loading) return false

  return (
    <Text size="small" color={COLORS.dark3}>
      ({data?.serviceOrdersCount})
    </Text>
  )
}

export default ListCounter
